import React from 'react';

// Static training/reference docs for internal teams. Plain HTML files served
// from the CRA public/ folder (frontend/public/training/) — no backend, no DB.
// Add a new entry here whenever a new playbook/guide is dropped into that folder.
const DOCS = [
  {
    key: 'pricing-desk',
    title: 'The Pricing Desk',
    subtitle: 'Rate Shopper · Price Intelligence · Revenue Manager (RMS)',
    description: 'Trainer playbook for Sales, Ops, and Tech — how to configure each product step by step, and what to say screen-by-screen when demoing to a hotelier.',
    href: '/training/pricing-desk-playbook.html',
  },
  {
    key: 'banquet-desk',
    title: 'The Banquet Desk',
    subtitle: 'Banquet CRM · Lead Arbitration · Banquet Intelligence',
    description: 'Trainer playbook for Sales, Ops, and Tech — the banquet sales pipeline, the EaseCRM sync, the one paid AI add-on (Lead Arbitration), and the bundled AI screens (Competitor Intelligence, Demand Forecast, Pricing Advisor, Variance Report).',
    href: '/training/banquet-desk-playbook.html',
  },
  {
    key: 'channel-desk',
    title: 'The Channel Desk',
    subtitle: 'EASEROOM Channel Manager — inventory, rate & booking sync',
    description: 'Ops/Tech reference — every event that fires an inventory or rate push to EaseRoom, how inbound OTA bookings land back in the PMS, and exactly which log screen to check for each one.',
    href: '/training/channel-desk-playbook.html',
  },
];

function TrainingMaterial() {
  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary-dark)' }}>Training Material</h2>
      <p style={{ color: 'var(--theme-text-secondary)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
        Internal playbooks and reference guides for onboarding, sales, and support. These are static pages — open one in a new tab and share the link directly with your team.
      </p>

      <div style={{ display: 'grid', gap: '1rem', maxWidth: 720 }}>
        {DOCS.map((doc) => (
          <a
            key={doc.key}
            href={doc.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'block', padding: '1.1rem 1.3rem', borderRadius: 10,
              border: '1px solid var(--theme-border)', background: 'var(--theme-bg-light)',
              textDecoration: 'none', color: 'inherit',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
              <h3 style={{ margin: 0, color: 'var(--theme-primary-dark)', fontSize: '1.05rem' }}>{doc.title}</h3>
              <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--theme-primary)' }}>Open ↗</span>
            </div>
            <div style={{ fontSize: '0.8rem', color: 'var(--theme-text-secondary)', marginTop: '0.2rem', fontWeight: 600 }}>{doc.subtitle}</div>
            <p style={{ margin: '0.5rem 0 0', fontSize: '0.87rem', color: 'var(--theme-text-secondary)' }}>{doc.description}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

export default TrainingMaterial;
